import React from "react";
import useSubscriptionFeatureStore from "../store/useSubscriptionFeatureStore";
import LockedFeaturePage from "../pages/LockedFeature/LockedFeaturePage";

/**
 * Wraps a route element — renders LockedFeaturePage if the subscription
 * doesn't include the required feature.
 *
 * Usage in the Routes.jsx:
 *   <FeatureRoute feature="your_feature_code"><RouteList /></FeatureRoute>
 */
const FeatureRoute = ({ feature, children, fallback }) => {
  const featureCodes = useSubscriptionFeatureStore((s) => s.featureCodes);
  const featureCodesLoaded = useSubscriptionFeatureStore((s) => s.featureCodesLoaded);

  // Still loading — render nothing to avoid a flicker
  if (!featureCodesLoaded) return null;

  return featureCodes.includes(feature)
    ? children
    : (fallback || <LockedFeaturePage featureName={feature} />);
};

export default FeatureRoute;